import { Box, Container, Slide, Link, Divider } from "@mui/material";
import { useState } from "react";
import { pages } from "../data/config";

// COMPONENTS
import CloseIcon from '@mui/icons-material/Close';
import MobileNavigationMenuButton from "./MobileNavigationMenuButton";

// ASSET
import PRPLogo from '../assets/prp_logo.png';

// MOBILE NAVIGATION MENU
export default function MobileNavigationMenu({ setMobileNavMenuVisibility }: MobileNavigationMenuProps) {
    const [shouldSlide, setSlideState] = useState(true);

    // RETURN ELEMENT
    return (
        <Box sx={{ width: '100%', height: '100%', position: 'absolute', zIndex: 99999, bgcolor: 'rgba(0, 0, 0, .65)' }}>
            <Box display="flex" justifyContent="flex-end">
                <Slide in={shouldSlide} direction="left">
                    <Box
                        sx={{
                            height: '100%',
                            py: 4,
                            top: 0,
                            right: 0,
                            position: 'fixed',
                            bgcolor: 'var(--backgroundcolor2)'
                        }}
                    >
                        <Container maxWidth="md">
                            <Box display="flex" justifyContent="space-between" sx={{ mb: 5, mx: 2 }}>
                                <Link href="https://productionrp.org/" target="_blank">
                                    <img
                                        width="45"
                                        src={PRPLogo}
                                        alt="PRP Logo"
                                        draggable="false"
                                        loading="lazy"
                                    />
                                </Link>

                                <CloseIcon
                                    sx={{
                                        '&:hover': {
                                            color: 'var(--teal_brighter)'
                                        },
                                        fontSize: 45,
                                        cursor: 'pointer',
                                        transition: '.23s',
                                        color: 'white'
                                    }}
                                    onClick={() => {
                                        setSlideState(false);
                                        setTimeout(() => setMobileNavMenuVisibility(false), 150);
                                    }}
                                />
                            </Box>

                            <Divider sx={{ mb: 3 }} />

                            {/* NAV BUTTONS */}
                            {pages.map(page => (
                                <MobileNavigationMenuButton key={page} name={page} />
                            ))}
                        </Container>
                    </Box>
                </Slide>
            </Box>
        </Box>
    )
}
